<template>
    <div class="fileUploader">

        <div v-if="imagePath" class="fileUploader__fileContainer">
            <div class="uploadedFile">
                <img :src="imagePath" alt="">
                <a v-if="deleteLink" :href="deleteLink" class="uploadedFile__delete">
                    <svg>
                        <use xlink:href="#close"></use>
                    </svg>
                </a>
            </div>
        </div>
        <div v-if="picture" class="fileUploader__fileContainer">
            <div class="uploadedFile">
                <img :src="picture" alt="">
                <a href="#" @click="emptyInput" class="uploadedFile__delete">
                    <svg>
                        <use xlink:href="#close"></use>
                    </svg>
                </a>
            </div>
        </div>

        <label :for="id" v-show="!picture && !imagePath" class="dropArea">
            <svg class="dropArea__icon">
                <use xlink:href="#upload"></use>
            </svg>
            <h2 class="dropArea__title">{{ picture ? labelSwitch : label }}</h2>
            <p class="section__infos" v-if="instructions">
                <svg viewBox="0 0 24 24">
                    <use xlink:href="#information"></use>
                </svg>
                {{ instructions }}
            </p>
            <input :id="id" type="file" :accept="accept" @change="setImage($event)" class="dropArea__input">
        </label>

        <input
            v-if="picture"
            type='hidden'
            :name="name"
            v-model="picture"/>

        <Modal ref="cropmodal" size="modal--mini">
            <div slot="content">

                <slot name="content"></slot>

                <vue-cropper-js
                    ref="cropper"
                    :aspect-ratio="1 / 1"
                    :src="imgPreviewSrc"
                    :autoCropArea="1"
                />
                <div class="form-group">
                    <div class="btn-group">
                        <button type="button" class="btn-green" @click="cropImage()">Crop</button>
                        <button type="button" class="btn--underline" @click="toggleModal()">Cancel</button>
                    </div>
                </div>

            </div>
        </Modal>


    </div>
</template>

<style lang="scss" scoped>
.section__infos {
    display: block;
}

.fileUploader {
    background: #ececec;
    border: 2px dashed #57BAD4;
    position: relative;
    padding: 30px;
}

.dropArea {
    text-align: center;

    &__icon {
        width: 64px;
        height: 64px;
        margin: 15px;
        fill: #9f9f9f;
    }

    &__title {
        color: #57BAD4;
        margin: 15px;
    }

    &__input {
        background: #000;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
        cursor: pointer;
    }
}

.uploadedFile {
    position: relative;
    width: 200px;

    &__link {
        display: inline-flex;
        flex-direction: column;
        align-items: center;
        text-decoration: none;
    }

    &__name {
        display: inline-block;
        background: black;
        color: white;
        border-radius: 50px;
        font-size: 12px;
        padding: 2px 10px;
        margin-top: 1em;
    }

    &__delete {
        position: absolute;
        top: 0;
        right: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        background: black;
        color: white;
        border-radius: 50%;
        width: 40px;
        height: 40px;
        transform: translate(50%, -50%);

        svg {
            fill: currentColor;
            max-width: 100%;
            width: 16px;
            height: 16px;
        }

        &:hover {
            background: #57BAD4;
        }
    }
}
</style>

<script>

import Modal from "../layout/Modal";
import VueCropperJs from "vue-cropperjs";

export default {
    components: {
        VueCropperJs, Modal
    },
    props: {
        label: {
            type: String,
            default: 'Ajouter un fichier'
        },
        labelView: {
            type: String,
            default: 'Voir le fichier'
        },
        labelSwitch: {
            type: String,
            default: 'Remplacer le fichier'
        },
        labelRemove: {
            type: String,
            default: 'Supprimer le fichier'
        },
        modalCrop: {
            type: String,
            default: 'Couper'
        },
        modalCancel: {
            type: String,
            default: 'Annuler'
        },
        instructions: String,
        name: {
            type: String
        },
        accept: {
            type: String,
            default: "image/*"
        },
        stored: String,
        deleteLink: String,
        show: {
            type: Boolean,
            default: false,
        },
        elementId: Number,
        elementName: {
            type: String,
            default: 'picture'
        },
        fileName: {
            type: String,
            default: 'Votre fichier'
        },
    },
    data() {
        return {
            id: null,
            imagePath: this.stored,
            imgPreviewSrc: '',
            picture: '',
            modalShow: false
        }
    },
    mounted() {
        this.id = 'file_uploader-' + this._uid
    },
    methods: {
        emptyInput(event) {
            event.preventDefault()
            document.getElementById(this.id).value = ''
            this.picture = '';
        },

        toggleModal() {
            //this.modalShow = !this.modalShow;
            if (!this.$refs.cropmodal.isOpen) {
                this.$root.$el.appendChild(this.$refs.cropmodal.$el);
            } else {
                this.$root.$el.removeChild(this.$refs.cropmodal.$el)
            }
            this.$refs.cropmodal.toggleModal();
        },

        cropImage() {
            // get image data for post processing, e.g. upload or setting image src
            //Vue.set(, ...this.illustrationsList[index] });
            this.picture = this.$refs.cropper.getCroppedCanvas({
                width: 512,
                height: 512,
                minWidth: 512,
                minHeight: 512,
                maxWidth: 1024,
                maxHeight: 1024,
                fillColor: '#ffffff',
                imageSmoothingEnabled: false,
                imageSmoothingQuality: 'high',
            }).toDataURL()
            this.toggleModal()
            //Vue.set(this.illustrationsList[this.selectedIndex], "imageFile", (this.$refs.cropper as any).getCroppedCanvas().toDataURL());
        },

        setImage(event) {
            let file = event.target.files[0];
            if (!file || file.type.indexOf('image/') === -1) {
                return;
            }
            if (typeof FileReader === 'function') {
                const reader = new FileReader();
                reader.onload = (event) => {
                    this.imgPreviewSrc = event.target.result;
                    // rebuild cropperjs with the updated source
                    this.$refs.cropper.replace(event.target.result);
                };
                reader.readAsDataURL(file);

                this.toggleModal();
            } else {
                alert('Sorry, FileReader API not supported');
            }


            //this.picture = URL.createObjectURL(file);
            //this.$emit('picture-changed', [this.elementId, this.elementName, this.picture])
        }
    },
    /*watch: {
        picture: function () {
            let url = this.picture;
        },
        stored: {
            // the callback will be called immediately after the start of the observation
            immediate: true,
            handler(val, oldVal) {
                // do your stuff
                this.picture = val;
            }
        }
    },*/
}
</script>
